import React from 'react';
export function Footer() {
  return <footer className="bg-[#3A3226] text-white/80 py-12 px-6" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <div className="text-center mb-8" data-id="element-13">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-14">
            Los Secretos de la Abuela
          </h3>
          <p className="text-white/60" data-id="element-15">
            Sabiduría tradicional para el hogar moderno
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-16">
          

          <div data-id="element-17">
            <h4 className="font-semibold text-white mb-3" data-id="element-18">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-19">
              <li data-id="element-20">
                <a href="#" className="hover:text-white transition-colors" data-id="element-21">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-22">
                <a href="#" className="hover:text-white transition-colors" data-id="element-23">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-24">
                <a href="#" className="hover:text-white transition-colors" data-id="element-25">
                  Política de Reembolso
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-26">
            
            
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 text-center text-sm" data-id="element-27">
          <p className="mb-2" data-id="element-28">
            © {new Date().getFullYear()} Los Secretos de la Abuela. Todos los
            derechos reservados.
          </p>
          <p className="text-white/60 text-xs" data-id="element-29">
            Este sitio no es parte de Facebook o Facebook Inc. Además, este
            sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK es
            una marca registrada de FACEBOOK, Inc.
          </p>
          <p className="text-white/60 text-xs mt-2" data-id="element-30">
            Los resultados pueden variar. Los testimonios no son necesariamente
            representativos de todos los que usan nuestros productos.
          </p>
        </div>
      </div>
    </footer>;
}